module.exports = __webpack_public_path__ + "media/images/new/avatar-Brodgers-af62ad8e0a53146606d369fc590a37dc.png";